'use strict';

angular.module('iamSystemModule', []);